/**
 * HOOK: useForms
 * Gestion des formulaires personnalisables
 * Utilise useCRUD pour bénéficier de toutes les opérations standard
 */

import { useCRUD } from './useCRUD';
import type { Form, CreateFormDto, UpdateFormDto } from '../types/form';

export function useForms() {
  const crud = useCRUD<Form, CreateFormDto, UpdateFormDto>('forms', {
    select: `
      *,
      origin:origins(id, name, label),
      product:products(id, name),
      fields:form_fields(count)
    `,
    orderBy: { column: 'created_at', ascending: false },
    transform: (raw: any) => ({
      ...raw,
      // Transformer le count en nombre simple
      submissions_count: raw.fields?.[0]?.count || 0,
    }),
    transformInput: (data: any) => ({
      ...data,
      // Transformer les chaînes vides en null pour les UUID
      product_id: data.product_id === '' ? null : data.product_id,
      origin_id: data.origin_id === '' ? null : data.origin_id,
    }),
  });

  return {
    // API spécifique (noms clairs)
    forms: crud.data,
    loading: crud.loading,
    error: crud.error,
    refreshForms: crud.refresh,
    getFormById: crud.getById,
    createForm: crud.create,
    updateForm: crud.update,
    deleteForm: crud.remove,
    deleteForms: crud.removeMany,

    // API générique (pour useEntityList)
    data: crud.data,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
    removeMany: crud.removeMany,
  };
}
